export default __webpack_public_path__ + "static/how-we-work-cover-61ecc1348c5bd1dc01630bd9306c1eab.webp";